import { render, staticRenderFns } from "./ParkingStatTab.vue?vue&type=template&id=60506a76"
import script from "./ParkingStatTab.vue?vue&type=script&lang=js"
export * from "./ParkingStatTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports